import { render, staticRenderFns } from "./OneTimeCodeForgot.vue?vue&type=template&id=7827f44a&scoped=true&"
import script from "./OneTimeCodeForgot.vue?vue&type=script&lang=ts&"
export * from "./OneTimeCodeForgot.vue?vue&type=script&lang=ts&"
import style0 from "./OneTimeCodeForgot.vue?vue&type=style&index=0&id=7827f44a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7827f44a",
  null
  
)

export default component.exports